module.exports = {"active":"Active","all_outlets":"All outlets","applicable_outlets":"Applicable outlets","availability":"Availability","details":"Details","end_date":"End date","inactive":"Inactive","name":"Name","no_date":"No date","select_status":"Select status","start_date":"Start date","status":"Status","type":"Type"};


//////////////////
// WEBPACK FOOTER
// ./resources/lang/en/model.php
// module id = j5La
// module chunks = 99